import { Pipe, PipeTransform } from '@angular/core';

import { convert, Unit } from '../../util/units';


@Pipe({
  name: 'convert'
})
export class ConvertPipe implements PipeTransform {
  /**
   * Transforms a value from one unit to another.
   * @param value Value to convert
   * @param {Unit} from Source unit
   * @param {Unit} to Destination unit
   * @return {number} Converted value
   */
  transform(value: number, from: Unit, to: Unit): number {
    return value !== null ? convert(value, from, to) : null;
  }
}
